import moment from 'moment';
import {
  SET_FIRST_NAME,
  SET_LAST_NAME,
  SET_EMAIL_ADDRESS,
  SET_MOBILE_PHONE,
  SET_DATE_OF_BIRTH,
  SET_GENDER,
  SET_MARITAL_STATUS,
  SET_USER_NAME,
  SET_PASSWORD,
  SET_FIRST_NAME_ERRORS,
  SET_LAST_NAME_ERRORS,
  SET_EMAIL_ADDRESS_ERRORS,
  SET_MOBILE_PHONE_ERRORS,
  SET_DATE_OF_BIRTH_ERRORS,
  SET_GENDER_ERRORS,
  SET_MARITAL_STATUS_ERRORS,
  SET_USER_NAME_ERRORS,
  SET_PASSWORD_ERRORS,
  SET_ERRORS
} from '../actionTypes/me';


export const setFirstName = (value) => ({
  type: SET_FIRST_NAME,
  value: value
});

export const setLastName = (value) => ({
  type: SET_LAST_NAME,
  value: value
});

export const setEmailAddress = (value) => ({
  type: SET_EMAIL_ADDRESS,
  value: value
});

export const setMobilePhone = (value) => ({
  type: SET_MOBILE_PHONE,
  value: value
});

export const setDateOfBirth = (value) => ({
  type: SET_DATE_OF_BIRTH,
  value: moment.isMoment(value) ? value.format('YYYY-MM-DD') : value
});

export const setGender = (value) => ({
  type: SET_GENDER,
  value: value
});

export const setMaritalStatus = (value) => ({
  type: SET_MARITAL_STATUS,
  value: value
});

export const setUserName = (value) => ({
  type: SET_USER_NAME,
  value
});

export const setPassword = (value) => ({
  type: SET_PASSWORD,
  value
});


/*** Error setters ***/

export const setFirstNameErrors = (errors) => ({
  type: SET_FIRST_NAME_ERRORS,
  errors: errors
});

export const setLastNameErrors = (errors) => ({
  type: SET_LAST_NAME_ERRORS,
  errors: errors
});

export const setEmailAddressErrors = (errors) => ({
  type: SET_EMAIL_ADDRESS_ERRORS,
  errors: errors
});

export const setMobilePhoneErrors = (errors) => ({
  type: SET_MOBILE_PHONE_ERRORS,
  errors: errors
});

export const setDateOfBirthErrors = (errors) => ({
  type: SET_DATE_OF_BIRTH_ERRORS,
  errors: errors
});

export const setGenderErrors = (errors) => ({
  type: SET_GENDER_ERRORS,
  errors: errors
});

export const setMaritalStatusErrors = (errors) => ({
  type: SET_MARITAL_STATUS_ERRORS,
  errors: errors
});

export const setUserNameErrors = (errors) => ({
  type: SET_USER_NAME_ERRORS,
  errors
});

export const setPasswordErrors = (errors) => ({
  type: SET_PASSWORD_ERRORS,
  errors
});

export const setErrors = (errors) => ({
  type: SET_ERRORS,
  errors
});


// WEBPACK FOOTER //
// ./src/actions/me.js